import styled from 'styled-components';
import { H4 } from '../base/typography';

export const Wrapper = styled.div``;

export const TextWrapper = styled.div`
	padding-right: 27%;
`;

export const InfoTextTitleWrapper = styled.div`
	display: flex;
	align-items: center;
	margin-bottom: 3rem;
`;

export const IconTextImage = styled.img`
	width: 4rem;
	height: 4rem;
	margin-right: 2rem;
`;

export const IconTextTitle = styled(H4)`
	max-width: 75%;
`;

export const IconText = styled.div`
	margin-bottom: 3rem;
`;
